import React from "react";
import useCountUp from "../hooks/useCountUp";

const Stat = ({ number, suffix = "", prefix = "", label }) => {
  const { ref, display } = useCountUp(number, { duration: 2200, suffix, prefix });
  return (
    <div className="pt-stat" ref={ref}>
      <div className="v">{display}</div>
      <div className="l">{label}</div>
    </div>
  );
};

export default Stat;
